/**
 * Seed payment data for mock mode.
 *
 * `customerId` values map to the ids in `mockCustomers.ts` (cust-001 … cust-006)
 * so the per-customer payments panel resolves names in dev. The set spans the
 * full status / method / gateway range for realistic filtering.
 */

import type { Payment } from '@/types/payment.types'

export const mockPayments: Payment[] = [
  {
    id: 'pay-001',
    tenantId: 'default',
    customerId: 'cust-001',
    customerName: 'Ramesh Kumar Verma',
    amount: 18500,
    currency: 'INR',
    paymentMethod: 'upi',
    gateway: 'razorpay',
    status: 'completed',
    transactionId: 'rzp_AB12CD34EF',
    description: 'ITR filing fee — AY 2024-25',
    paidAt: '2026-05-12T09:24:00Z',
    createdAt: '2026-05-12T09:20:00Z',
    updatedAt: '2026-05-12T09:24:00Z',
  },
  {
    id: 'pay-002',
    tenantId: 'default',
    customerId: 'cust-002',
    customerName: 'Priya Sharma',
    amount: 42000,
    currency: 'INR',
    paymentMethod: 'net_banking',
    gateway: 'razorpay',
    status: 'completed',
    transactionId: 'rzp_GH56IJ78KL',
    description: 'Capital gains advisory — quarterly',
    paidAt: '2026-05-28T14:02:00Z',
    createdAt: '2026-05-28T13:55:00Z',
    updatedAt: '2026-05-28T14:02:00Z',
  },
  {
    id: 'pay-003',
    tenantId: 'default',
    customerId: 'cust-003',
    customerName: 'Vikram Singh Rajput',
    amount: 95000,
    currency: 'INR',
    paymentMethod: 'bank_transfer',
    gateway: 'manual',
    status: 'pending',
    transactionId: null,
    description: 'Annual retainer — rental income portfolio',
    paidAt: null,
    createdAt: '2026-06-02T10:15:00Z',
    updatedAt: '2026-06-02T10:15:00Z',
  },
  {
    id: 'pay-004',
    tenantId: 'default',
    customerId: 'cust-004',
    customerName: 'Ananya Krishnamurthy',
    amount: 12000,
    currency: 'INR',
    paymentMethod: 'credit_card',
    gateway: 'stripe',
    status: 'processing',
    transactionId: 'pi_3KdfgStripe01',
    description: 'GST return preparation — May 2026',
    paidAt: null,
    createdAt: '2026-06-08T08:40:00Z',
    updatedAt: '2026-06-08T08:42:00Z',
  },
  {
    id: 'pay-005',
    tenantId: 'default',
    customerId: 'cust-005',
    customerName: 'Sanjay Mehta',
    amount: 7500,
    currency: 'INR',
    paymentMethod: 'wallet',
    gateway: 'paytm',
    status: 'failed',
    transactionId: 'ptm_FAIL90X1',
    description: 'TDS reconciliation fee',
    paidAt: null,
    createdAt: '2026-06-05T16:30:00Z',
    updatedAt: '2026-06-05T16:33:00Z',
  },
  {
    id: 'pay-006',
    tenantId: 'default',
    customerId: 'cust-001',
    customerName: 'Ramesh Kumar Verma',
    amount: 5000,
    currency: 'INR',
    paymentMethod: 'upi',
    gateway: 'phonepe',
    status: 'refunded',
    transactionId: 'ppe_RFND2210',
    description: 'Duplicate filing fee — refunded',
    paidAt: '2026-04-20T11:00:00Z',
    createdAt: '2026-04-19T11:00:00Z',
    updatedAt: '2026-04-22T09:10:00Z',
  },
  {
    id: 'pay-007',
    tenantId: 'default',
    customerId: 'cust-006',
    customerName: 'Kavitha Nair',
    amount: 28000,
    currency: 'INR',
    paymentMethod: 'debit_card',
    gateway: 'razorpay',
    status: 'completed',
    transactionId: 'rzp_MN90OP12QR',
    description: 'Audit support engagement — phase 1',
    paidAt: '2026-06-09T12:48:00Z',
    createdAt: '2026-06-09T12:40:00Z',
    updatedAt: '2026-06-09T12:48:00Z',
  },
  {
    id: 'pay-008',
    tenantId: 'default',
    customerId: 'cust-002',
    customerName: 'Priya Sharma',
    amount: 3200,
    currency: 'INR',
    paymentMethod: 'upi',
    gateway: 'razorpay',
    status: 'cancelled',
    transactionId: null,
    description: 'Consultation booking — cancelled by client',
    paidAt: null,
    createdAt: '2026-06-01T09:00:00Z',
    updatedAt: '2026-06-01T09:30:00Z',
  },
]
